module.exports = __webpack_public_path__ + "static/media/vizz.a985aada.jpg";